import { Divider, SxProps, Theme } from '@mui/material';
import { formatTranslation } from 'intl';
import { UserTranslationKeys } from 'intl/keys';
import { useBacktrack } from 'components/common/withBacktrack';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withProcessesData } from 'components/common/withProcessesData';
import {
  useCreateUser,
  withCreateUser,
} from 'components/dataCreationForms/user/withCreateUser';
import { WithInputForm } from 'components/dataCreationForms/withInputForm';
import { withUsers } from 'components/dataProviders/withUsers';
import { MemoUserForm } from 'components/user/form';
import { useFormCleanupOnUnmount } from 'presentation/dialogForms/dialogFormsHooks';
import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import ViewWrapper from 'components/core/Layout/ViewWrapper';
import { inspectionSubheaderBaseSx } from 'components/inspection/layout';
import { SubheaderText } from 'components/general';
import { SubmitFooter } from 'components/submitFooter';

const subheaderSx: SxProps<Theme> = {
  ...inspectionSubheaderBaseSx,
  mt: 4,
};

const dividerSx: SxProps<Theme> = {
  my: 4,
};

function CreateUserWizardContainer(): React.ReactElement {
  const {
    submitForm,
    isPosting,
    initialValues,
    releaseSubmitEvent,
    SUBMIT_EVENT_TYPE,
    handleFormValidation,
    validate,
  } = useCreateUser();
  const intl = useIntl();

  const { back } = useBacktrack();
  const formName = 'user';
  useFormCleanupOnUnmount(formName);
  const onCancel = useCallback(() => {
    back();
  }, [back]);

  return (
    <>
      <ViewWrapper>
        <WithInputForm
          values={initialValues}
          errors={{}}
          handleFormValidation={handleFormValidation}
          handleFieldValidation={validate}
          onSubmit={submitForm}
          eventType={SUBMIT_EVENT_TYPE}
          dispatchSubmit={releaseSubmitEvent}
          formName={formName}
        >
          <SubheaderText sx={subheaderSx}>
            {formatTranslation(intl, UserTranslationKeys.addUserSection)}
          </SubheaderText>

          <Divider sx={dividerSx} />

          <MemoUserForm
            isDialog={false}
            editedUserId={null}
            existingRoleId={null}
          />
        </WithInputForm>
      </ViewWrapper>

      <SubmitFooter
        isPosting={isPosting}
        onCancel={onCancel}
        onSubmit={releaseSubmitEvent}
      />
    </>
  );
}

export const MemoCreateUserWizardContainer = memo(
  composeHOCs(
    withProcessesData,
    withUsers,
    withCreateUser
  )(CreateUserWizardContainer)
);
